import React from 'react';
import { Image } from 'antd';
import styles from './GeneralCvIntro.module.scss';
import { useTranslation } from 'next-i18next';

type GeneralCvIntroProps = {
  clientColor: string;
};

const GeneralCvIntro: React.FC<GeneralCvIntroProps> = ({ clientColor }) => {
  const { t: translate } = useTranslation('form');

  return (
    <div className={styles.generalCvIntroWrap} id="general-cv-section">
      <div className={styles.generalCvText}>
        <h2 className={styles.title}>{translate('send_your_cv')}</h2>
        <p className={styles.description}>{translate('send_cv_description')}</p>
      </div>
      <div className={styles.generalCvIcon} style={{ backgroundColor: clientColor }}>
        <Image
          src="/assets/images/client-images/romeo-juliet-general-cv.png"
          alt="Icon for general cv form"
          preview={false}
          className={styles.mainImage}
        />
      </div>
    </div>
  );
};

export default GeneralCvIntro;
